"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_THREADS_SORT_COLUMNS = [
    "id",
    "subject",
    "priority",
    "status",
    "createdAt",
    "updatedAt",
    "threadEvents",
];
//# sourceMappingURL=get-threads-parameters.js.map